<template>
  <div class="equipment-manage-container">
    <Card>
      <p slot="title">设备管理</p>

      <div class="search-con">
        <Select
          v-model="searchParams.epermit"
          placeholder="请选择权限状态"
          style="width: 160px; margin-right: 10px"
          clearable
          @on-change="handleSearch"
        >
          <Option value="">全部</Option>
          <Option :value="0">待审核</Option>
          <Option :value="1">已授权</Option>
          <Option :value="2">已拒绝</Option>
        </Select>
        <Select
          v-model="searchParams.etype"
          placeholder="请选择设备类型"
          style="width: 160px; margin-right: 10px"
          clearable
          @on-change="handleSearch"
        >
          <Option value="">全部</Option>
          <Option v-for="item in deviceTypeOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
        <Input
          v-model="searchParams.keyword"
          placeholder="请输入设备名称/SN搜索"
          style="width: 220px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        >
          <span slot="prepend">搜索</span>
        </Input>
        <Input
          v-model="searchParams.ip"
          placeholder="IP地址"
          style="width: 160px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        />
        <Input
          v-model="searchParams.PubicIp"
          placeholder="公网IP"
          style="width: 160px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        />
        <Input
          v-model="searchParams.bz"
          placeholder="备注"
          style="width: 160px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        />
        <Button type="primary" @click="handleSearch">搜索</Button>
      </div>

      <div style="margin-top: 20px">
        <Table
          :columns="columns"
          :data="tableData"
          :loading="loading"
          border
          stripe
        >
          <template slot-scope="{ row }" slot="epermit">
            <Tag :color="epermitColorMap[row.Epermit]">
              {{ epermitNameMap[row.Epermit] || row.Epermit }}
            </Tag>
          </template>
          <template slot-scope="{ row }" slot="estate_CN">
            <Tag :color="estateColorMap[row.Estate]">
              {{ row.Estate_CN }}
            </Tag>
          </template>

          <template slot-scope="{ row }" slot="estate">
            <i-switch
              v-model="row.Estate"
              :true-value="1"
              :false-value="0"
              @on-change="(val) => handleStatusChange(row, val)"
            >
              <span slot="open">在线</span>
              <span slot="close">离线</span>
            </i-switch>
          </template>

          <template slot-scope="{ row }" slot="action">
            <Button
              type="primary"
              size="small"
              @click="handleEdit(row)"
            >编辑</Button>
            <Button
              type="info"
              size="small"
              style="margin-left: 6px"
              @click="handleView(row)"
            >查看</Button>
            <Button
              v-if="row.Epermit === 0"
              type="success"
              size="small"
              style="margin-left: 6px"
              @click="handleApprove(row)"
            >审核通过</Button>
            <Button
              v-if="row.Epermit === 0"
              type="error"
              size="small"
              style="margin-left: 6px"
              @click="handleReject(row)"
            >审核拒绝</Button>
            <Button
              type="error"
              size="small"
              style="margin-left: 6px"
              @click="handleDelete(row)"
            >删除</Button>
          </template>
        </Table>

        <div style="margin-top: 20px; text-align: right">
          <Page
            :total="total"
            :current="pageParams.page"
            :page-size="pageParams.limit"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
            show-sizer
            show-total
          />
        </div>
      </div>
    </Card>

    <!-- 编辑弹窗 -->
    <Modal
      v-model="editModalVisible"
      title="编辑设备"
      width="600"
      @on-ok="handleEditSubmit"
      :loading="editSubmitting"
    >
      <Form ref="editForm" :model="editForm" :label-width="100">
        <FormItem label="设备参数">
          <Input v-model="editForm.Eparams" type="textarea" :rows="3" placeholder="请输入设备参数" />
        </FormItem>
        <FormItem label="参数包JSON">
          <Input v-model="editForm.EparamPack" type="textarea" :rows="6" placeholder='请输入JSON格式参数包，例如：{"twh":"A01","ztdx":"5","default_text":"无数据"}' />
        </FormItem>
        <FormItem label="版本号">
          <Input v-model="editForm.Ever" placeholder="请输入版本号" />
        </FormItem>
        <FormItem label="升级地址">
          <Input v-model="editForm.Eupurl" placeholder="请输入升级地址" />
        </FormItem>
        <FormItem label="包">
          <Input v-model="editForm.Remark" type="textarea" :rows="3" placeholder="请输入包名" />
        </FormItem>
        <FormItem label="备注">
          <Input v-model="editForm.Bz" type="textarea" :rows="3" placeholder="请输入备注" />
        </FormItem>
      </Form>
    </Modal>

    <!-- 查看弹窗 -->
    <Modal
      v-model="viewModalVisible"
      title="设备详情"
      width="720"
      footer-hide
    >
      <div class="detail-table-wrap">
        <table class="detail-table">
          <tbody>
            <tr v-for="(label, key) in detailFields" :key="key">
              <td class="detail-label">{{ label }}</td>
              <td class="detail-value">{{ currentDetailRow[key] !== undefined ? currentDetailRow[key] : '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getEquipmentList, approveEquipment, rejectEquipment, updateEquipmentStatus, deleteEquipment, editEquipment } from '@/api/equipment'
import { getsysparameterList } from '@/api/system/sys_parameter'

export default {
  name: 'EquipmentManage',

  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,

      searchParams: {
        keyword: '',
        epermit: '',
        etype: '',
        ip: '',
        PubicIp: '',
        bz: ''
      },
      deviceTypeOptions: [],
      pageParams: {
        page: 1,
        limit: 10
      },

      epermitNameMap: {
        0: '待审核',
        1: '已授权',
        2: '已拒绝'
      },
      epermitColorMap: {
        0: 'orange',
        1: 'green',
        2: 'red'
      },
      estateColorMap: {
        0: 'red',
        1: 'green',
        2: 'orange'
      },

      // 编辑弹窗
      editModalVisible: false,
      editSubmitting: false,
      editForm: {
        id: '',
        Eparams: '',
        EparamPack: '',
        Ever: '',
        Eupurl: '',
        Remark: '',
        Bz: ''
      },

      // 查看弹窗
      viewModalVisible: false,
      currentDetailRow: {},

      // 详情字段映射
      detailFields: {
        id: 'ID',
        Ename: '设备名称',
        Sn: '设备SN',
        Etype_CN: '设备类型',
        Eip: 'IP地址',
        PubicIp: '公网IP',
        Epermit: '权限状态',
        Estate: '设备状态',
        Eparams: '设备参数',
        EparamPack: '参数包(JSON)',
        Ever: '版本号',
        Eupurl: '升级地址',
        Remark: '包',
        Bz: '备注',
        Addtime: '注册时间',
        Updatetime: '更新时间'
      },

      columns: [
        { title: '设备名称', key: 'Ename', minWidth: 140, tooltip: true },
        { title: '设备SN', key: 'Sn', width: 160, tooltip: true },
        { title: '设备类型', key: 'Etype_CN', width: 120, tooltip: true },
        { title: 'IP地址', key: 'Eip', width: 150, tooltip: true },
        { title: '公网IP', key: 'PubicIp', width: 150, tooltip: true },
        { title: '权限状态', slot: 'epermit', width: 100, tooltip: true },
        { title: '设备状态', slot: 'estate_CN', width: 100, tooltip: true },
        { title: '备注', key: 'Bz', minWidth: 120, tooltip: true },
        { title: '注册时间', key: 'Addtime', width: 170, tooltip: true },
        { title: '更新时间', key: 'Updatetime', width: 170, tooltip: true },
        { title: '操作', slot: 'action', width: 380, fixed: 'right', tooltip: true }
      ]
    }
  },

  mounted () {
    this.getList()
    this.fetchDeviceTypes()
  },

  methods: {
    async fetchDeviceTypes () {
      try {
        const res = await getsysparameterList('', '', '', 1, 100, 'equipment_info')
        if (res.data.code === 0) {
          const list = res.data.data.list || res.data.data || []
          this.deviceTypeOptions = list
            .filter(item => item.field === 'Etype')
            .map(item => ({ value: item.value, label: item.meaning }))
        }
      } catch (e) {
        console.error('获取设备类型失败', e)
      }
    },

    async getList () {
      this.loading = true
      try {
        const res = await getEquipmentList({
          page: this.pageParams.page,
          limit: this.pageParams.limit,
          keyword: this.searchParams.keyword,
          epermit: this.searchParams.epermit,
          etype: this.searchParams.etype,
          ip: this.searchParams.ip,
          PubicIp: this.searchParams.PubicIp,
          bz: this.searchParams.bz
        })
        if (res.data.code === 0) {
          const result = res.data.data || {}
          this.tableData = (result.list || []).map(item => ({
            ...item,
            estateSwitch: item.Estate
          }))
          this.total = result.total || 0
        } else {
          this.$Message.error(res.data.msg || '获取列表失败')
        }
      } catch (error) {
        this.$Message.error('获取列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.pageParams.page = 1
      this.getList()
    },

    handlePageChange (page) {
      this.pageParams.page = page
      this.getList()
    },

    handlePageSizeChange (size) {
      this.pageParams.limit = size
      this.pageParams.page = 1
      this.getList()
    },

    // 编辑
    handleEdit (row) {
      this.editForm = {
        id: row.id,
        Eparams: row.Eparams || '',
        EparamPack: row.EparamPack || '',
        Ever: row.Ever || '',
        Eupurl: row.Eupurl || '',
        Remark: row.Remark || '',
        Bz: row.Bz || ''
      }
      this.editModalVisible = true
    },

    async handleEditSubmit () {
      this.editSubmitting = true
      try {
        const res = await editEquipment(this.editForm)
        if (res.data.code === 0) {
          this.$Message.success('编辑成功')
          this.editModalVisible = false
          this.getList()
        } else {
          this.$Message.error(res.data.msg || '编辑失败')
        }
      } catch (error) {
        this.$Message.error('编辑失败')
        console.error(error)
      } finally {
        this.editSubmitting = false
      }
    },

    // 查看
    handleView (row) {
      this.currentDetailRow = row
      this.viewModalVisible = true
    },

    // 审核
    async handleApprove (row) {
      try {
        const res = await approveEquipment({ id: row.id })
        if (res.data.code === 0) {
          this.$Message.success('审核通过')
          this.getList()
        } else {
          this.$Message.error(res.data.msg || '操作失败')
        }
      } catch (error) {
        this.$Message.error('操作失败')
        console.error(error)
      }
    },

    async handleReject (row) {
      try {
        const res = await rejectEquipment({ id: row.id })
        if (res.data.code === 0) {
          this.$Message.success('已拒绝')
          this.getList()
        } else {
          this.$Message.error(res.data.msg || '操作失败')
        }
      } catch (error) {
        this.$Message.error('操作失败')
        console.error(error)
      }
    },

    async handleStatusChange (row, val) {
      try {
        const res = await updateEquipmentStatus({ id: row.id, Estate: val })
        if (res.data.code === 0) {
          this.$Message.success(val === 0 ? '已启用' : '已禁用')
          row.Estate = val
        } else {
          this.$Message.error(res.data.msg || '操作失败')
          row.estateSwitch = row.Estate
        }
      } catch (error) {
        this.$Message.error('操作失败')
        console.error(error)
        row.estateSwitch = row.Estate
      }
    },

    handleDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除设备「${row.Ename}」吗？`,
        onOk: async () => {
          try {
            const res = await deleteEquipment({ id: row.id })
            if (res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getList()
            } else {
              this.$Message.error(res.data.msg || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败')
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.equipment-manage-container {
  padding: 10px;
  background: #F5F5F5;
  min-height: 100%;
}

.search-con {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.detail-table-wrap {
  max-height: 500px;
  overflow-y: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
}

.detail-table tr {
  border-bottom: 1px solid #e8eaec;
}

.detail-table tr:last-child {
  border-bottom: none;
}

.detail-label {
  width: 140px;
  padding: 10px 12px;
  font-weight: bold;
  color: #515a6e;
  background: #f8f8f9;
  text-align: right;
  white-space: nowrap;
}

.detail-value {
  padding: 10px 12px;
  color: #515a6e;
  word-break: break-all;
}
</style>
